import { CanActivate, RedirectCommand, UrlTree } from '@angular/router';
import { AuthGuard, FeatureModulesService } from '@spartacus/core';
import { Observable, of, map, switchMap } from 'rxjs';
import { Injectable } from '@angular/core';

import { COMMON_ACCOUNT_FEATURE } from '../constants/common-features';

@Injectable({
  providedIn: 'root'
})
export class AccountModuleGuard implements CanActivate {
  constructor(
    private authGuard: AuthGuard,
    private featureModulesService: FeatureModulesService
  ) {}

  canActivate(): Observable<boolean | UrlTree | RedirectCommand> {
    return this.authGuard.canActivate().pipe(
      switchMap((canActivate) => (canActivate === true) ?
        this.featureModulesService.resolveFeature(COMMON_ACCOUNT_FEATURE).pipe(map(() => true)) :
        of(canActivate)
      )
    );
  }
}
